import convertMithril from 'util/dom/convert-mithril';
import pointMenu from 'legacy/components/point-menu/point-menu';
import popupModel from 'models/popup-model';

/**
 *  options: [{
 *      label: The display name.
 *      icon: An optional icon.
 *      callback: callback for option.
 *      isDelete: defaults to false
 *  }]
 *
 */

const OptionsPopup = {
    view: ({attrs: {options, pointMenuOpts, isBatch = false}}) => {
        return <i className={`icon-ellipsis ${isBatch ? 'batch-options UFtracker-more-batch-options' : 'asset-options'}`} onclick={e => {
            popupModel.close();
            return pointMenu({
                e,
                content: () => convertMithril.toDom(<div>
                    {
                        options.map(({
                            label,
                            icon,
                            callback,
                            isDelete,
                            cssWrapClass
                        }) => <div
                            onclick={(...args)=>{
                                callback(...args);
                                pointMenu.close();
                            }}
                            className={`menu-option${isDelete ? ' remove-link' : ''} ${cssWrapClass || ''}`}>
                            {icon && <i className={icon}/>}{label}
                        </div>)
                    }
                </div>),
                cssClass: 'link-list asset-options disabled',
                forceDesktop: true,
                noLine: true,
                ...pointMenuOpts
            });
        }}/>;
    }
};

export default OptionsPopup;
